/** @jsx h */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';

import PropType from 'prop-types';
import SecondaryNavigationItem from '../SecondaryNavigationItem';

import { navigationItemPropType } from '../../propTypes';

import { SecondaryNavigationContainer } from './styles';

const SecondaryNavigation = ({ secondaryMenu, primaryColor, alternateNavbarTheme }) => (
  <SecondaryNavigationContainer id="secondary-nav" role="navigation" alternate={alternateNavbarTheme}>
    {secondaryMenu.map(item => (
      <SecondaryNavigationItem
        item={item}
        sitePrimaryColor={primaryColor}
        alternate={alternateNavbarTheme}
      />
    ))}
  </SecondaryNavigationContainer>
);

SecondaryNavigation.propTypes = {
  secondaryMenu: PropType.arrayOf(navigationItemPropType),
  primaryColor: PropType.string,
  alternateNavbarTheme: PropType.bool,
};

SecondaryNavigation.defaultProps = {
  secondaryMenu: [],
  primaryColor: null,
  alternateNavbarTheme: false,
};

export default SecondaryNavigation;
